// extracted by mini-css-extract-plugin
export var banner = "_2p-0";
export var icon = "_2p-1";
export var message = "_2p-2";